import React from "react";
import PropTypes from "prop-types";
import { FaXTwitter } from "react-icons/fa6";
import encodeURI from "../../utils/encodeURI";
import SharingButton from "../SharingButton";

const Twitter = (props) => {
  const text = props.text || "Tweet";
  const shareText = encodeURI(props.shareText);
  const fullUrl = `https://x.com/intent/tweet/?text=${shareText}`;

  return (
    <SharingButton
      type="twitter"
      onClick={props.onClick}
      icon={<FaXTwitter />}
      text={text}
      fullUrl={fullUrl}
      bgColor={"bg-[#000000]"}
    />
  );
};

Twitter.propTypes = {
  text: PropTypes.string,
  shareText: PropTypes.string,
  onClick: PropTypes.func,
};

export default Twitter;
